var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animated fadeIn",attrs:{"id":"iframediv"}},[(_vm.attiva)?_c('highcharts',{attrs:{"options":_vm.chartOptions}}):_vm._e(),(!_vm.attiva)?_c('h1',[_vm._v("Funzione attiva solo dal 5 al 7 del mese")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }